import React from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {Panels, usePanelsUpdate} from 'Event/template/Panels'
import Styling from 'Event/template/Panels/Dashboard/LeftPanel/LeftPanelConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function LeftPanelConfig(props: ComponentConfigProps) {
  const {showing: isVisible, onClose} = props

  const update = usePanelsUpdate()
  const {control, handleSubmit, formState, watch} = useForm()
  const addTranslation = useAddTranslation()

  useAutoUpdate({
    values: watch(),
    when: isVisible,
  })

  const submit = (data: Panels) => {
    const text = replaceAtPath(data, 'leftPanel.text', '{{header_text}}')

    update({
      ...data,
      localization: addTranslation({
        header_text: text ?? '',
      }),
    })

    onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Left Panel Bar"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
